import { LoaderFunctionArgs } from "react-router";

export default async function marketplaceLoader(args: LoaderFunctionArgs) {
  return null;
}
